import type { MunicipalityBlockData } from "@/types";

interface MunicipalityCardProps {
  data: MunicipalityBlockData;
}

export function MunicipalityCard({ data }: MunicipalityCardProps) {
  return (
    <div className="cx-mc animate-cx-message-in">
      <div className="cx-mc-header">
        <span className="cx-mc-name">{data.display_name} · {data.county}</span>
        <span className="cx-mc-tag">Kommun</span>
      </div>

      <div className="cx-mc-hero">
        <div className="cx-mc-hero-value">{data.hero.value}</div>
        <div className="cx-mc-hero-label">{data.hero.label}</div>
      </div>

      <div className={`cx-mc-insight${data.quiet ? " cx-mc-insight--quiet" : ""}`}>
        {data.insight}
      </div>

      {data.context.length > 0 && (
        <div className="cx-mc-context">
          {data.context.map((c, i) => <span key={i}>{c}</span>)}
        </div>
      )}
    </div>
  );
}
